import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Alert, AlertService, TableConfig } from '@michelin/theme';
import { OrderReportService } from 'src/app/shared/services/report/order-report.service';
import { AutomakerSelectModalComponent } from '../automaker-select-modal/automaker-select-modal.component';
import { downloadResponseBlob } from 'src/app/shared/utils/functions';

export class ReportItem {
  name: string;
  description: string;
}

@Component({
    selector: 'app-list-report',
    templateUrl: './list-report.component.html',
    styleUrls: ['./list-report.component.scss'],
    standalone: false
})
export class ListReportComponent {
  loading = false;
  @ViewChild(AutomakerSelectModalComponent) automakerSelectModal: AutomakerSelectModalComponent;

  reports = new MatTableDataSource([
    {
      name: 'COMMISSION',
      description: 'Vendas e Comissão'
    },
    {
      name: 'ORDERS_NOT_SERVED',
      description: 'CAIs Não Atendidos'
    },
    {
      name: 'ORDERS_CANCELED',
      description: 'Pedidos Cancelados'
    },
    {
      name: 'ORDERS_FULL',
      description: 'Relatório Unificado'
    }
  ]);

  tableConfig: TableConfig<ReportItem> = {
    columns: {
      actions: { cell: 'actionsCell', header: ' ', width: '100px', align: 'center' },
      companyName: { header: 'Relatório', cell: (item) => item.description }
    }
  };

  constructor(private orderReportService: OrderReportService, private alertService: AlertService) {}

  downloadCommissionReport() {
    this.loading = true;
    this.orderReportService
      .getCommissionReport()
      .subscribe({
        next: (response) => {
          downloadResponseBlob(response, 'Relatorio_Vendas_Comissao');
        },
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao baixar o relatório de comissão.' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  downloadOrdersNotServedReport() {
    this.loading = true;
    this.orderReportService
      .getOrdersNotServedReport()
      .subscribe({
        next: (response) => {
          downloadResponseBlob(response, 'Relatorio_CAIs_Nao_Atendidos');
        },
        error: () =>
          this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao baixar o relatório de CAIs não atendidos.' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  downloadOrdersCanceledReport() {
    this.loading = true;
    this.orderReportService
      .getOrdersCanceledReport()
      .subscribe({
        next: (response) => {
          downloadResponseBlob(response, 'Relatorio_Pedidos_Cancelados');
        },
        error: () =>
          this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao baixar o relatório de Pedidos cancelados.' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  downloadOrdersFullReport(automakerId?: number | null) {
    this.loading = true;
    this.orderReportService
      .getOrdersFullReport(automakerId || undefined)
      .subscribe({
        next: (response) => {
          downloadResponseBlob(response, 'Relatorio_Pedidos_Unificados');
        },
        error: () =>
          this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao baixar o relatório de Pedidos unificados.' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  downloadReport(report: string) {
    switch (report) {
      case 'COMMISSION':
        this.downloadCommissionReport();
        break;
      case 'ORDERS_NOT_SERVED':
        this.downloadOrdersNotServedReport();
        break;
      case 'ORDERS_CANCELED':
        this.downloadOrdersCanceledReport();
        break;
      case 'ORDERS_FULL':
        // Abre modal de seleção de automaker
        this.automakerSelectModal.open();
        break;
    }
  }

  onAutomakerSelected(automakerId: number | null) {
    this.downloadOrdersFullReport(automakerId);
  }
}
